"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHECK_DATA_INCIDENT_SUB_TYPE = void 0;
exports.CHECK_DATA_INCIDENT_SUB_TYPE = {
    INVALID_TRANSPORT_DELAY: 'INVALID_TRANSPORT_DELAY',
    TRANSPORT_NOT_FOUND: 'TRANSPORT_NOT_FOUND',
    CONFLICTING_TRANSPORT_TYPE: 'CONFLICTING_TRANSPORT_TYPE',
    CONFLICTING_TRANSPORT_ADDRESS: 'CONFLICTING_TRANSPORT_ADDRESS',
    IMPRECISE_START_ADDRESS: 'IMPRECISE_START_ADDRESS',
    COMMENT_UPDATED: 'COMMENT_UPDATED',
};
